module.exports = __webpack_public_path__ + "img/4.598819ce.png";